<input #uploadInput
       style="display: none;"
       type="file"
       class="inputFile"
       (change)="emitUpload($event)"
       id="file"
       name="file"
       accept="image/png, image/gif, image/jpeg, video/mp4, application/pdf, .svg, application/vnd.ms-excel, .xml, .json"
       multiple />

<button mat-raised-button
        color="accent"
        cdkDropList
        [matMenuTriggerFor]="menuAddElement">
  {{'addItem' | translation}}
</button>

<mat-menu #menuAddElement="matMenu">

  <div class="mat-menu-button-wrapper" *ngIf="isAdmin || isDev">
    <mat-icon>folder</mat-icon>
    <button mat-menu-item (click)="checkTimeStampBefore('addConfig', null)">
      {{'addClientFile' | translation}}
    </button>
  </div>
  <div class="mat-menu-button-wrapper" *ngIf="!_shared.selectedDevice?.data.modules.mediaLimiter">
    <mat-icon>folder</mat-icon>
    <button mat-menu-item (click)="checkTimeStampBefore('startUpload', null)">
      {{'addFile' | translation}}
    </button>
  </div>

  <div class="mat-menu-button-wrapper" *ngIf="!_shared.selectedDevice?.data.modules.mediaLimiter">
    <mat-icon>folder</mat-icon>
    <button mat-menu-item (click)="checkTimeStampBefore('addFolder', null)">  {{'addFolder' | translation}}</button>
  </div>
  <div class="mat-menu-button-wrapper" *ngIf="_shared.selectedDevice?.data.modules.kiosk">
    <mat-icon>folder</mat-icon>
    <button mat-menu-item (click)="checkTimeStampBefore('import', 'web')">
      {{'importWeb' | translation}}
    </button>
  </div>
  <div class="mat-menu-button-wrapper" *ngIf="_shared.selectedDevice?.data.modules.quiz">
    <mat-icon>folder</mat-icon>
    <button mat-menu-item (click)="checkTimeStampBefore('import', 'quiz')">
      {{'importQuiz' | translation}}
    </button>
  </div>
  <div class="mat-menu-button-wrapper" *ngIf="_shared.selectedDevice?.data.modules.lottery">
    <mat-icon>folder</mat-icon>
    <button mat-menu-item (click)="checkTimeStampBefore('import', 'lottery')">
      {{'importLottery' | translation}}
    </button>
  </div>
</mat-menu>

<ng-container>


  <h1 (click)="goToRootFolder()">{{'home' | translation}}</h1>

  <mat-divider></mat-divider>

  <!--   cdkDropList
    (cdkDropListDropped)="drop($event)" -->
  <mat-tree [dataSource]="treeDataSource"
            [treeControl]="treeControl"
            cdkDropList
            (cdkDropListDropped)="drop($event)">


    <!--  cdkDropList  cdkDropList   [cdkDragData]="node" (cdkDragStarted)="dragStart()"
                   (cdkDragReleased)="dragEnd()"-->

    <ng-container *matTreeNodeDef="let node; when: isFolder">

      <ng-container>


        <mat-tree-node cdkDropList
                       (click)="setSelectedFolder(node); activeNode = node"
                       [ngClass]="{ 'background-highlight': activeNode === node, 'placeholder': !node.authorized && _firebase.user.assignedDevice && !_firebase.user.enableAllContent && _firebase.user.parentuid == '96oXRJRiaBNX5fWzodHlXlBrnUr2' }"
                       matTreeNodePadding
                       cdkDrag
                       [cdkDragData]="node"
                       (mouseenter)="dragHover(node)"
                       (mouseleave)="dragHoverEnd()"
                       (cdkDragStarted)="dragStart()"
                       (cdkDragReleased)="dragEnd()">
          <div fxLayout="row" fxLayout="center center" >
            <button mat-icon-button
                    matTreeNodeToggle
                    [attr.aria-label]="'toggle ' + node.filename">
              <mat-icon *ngIf="treeControl.isExpandable(node)"
                        class="mat-icon-rtl-mirror">
                {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
              </mat-icon>
            </button>
            <div fxLayout="row" fxLayout="center center" class="treeElement" *ngIf="node ">
              <mat-icon [matMenuTriggerFor]="menu">folder</mat-icon>
              <p>{{ node.displayName }}</p>
            </div>
            <mat-menu #menu="matMenu">
              <button *ngIf="!_firebase.user.assignedDevice" mat-menu-item (click)="checkTimeStampBefore('addFolder', node)">
                {{'createSubFolder' | translation}}
              </button>
              <button *ngIf="!_firebase.user.assignedDevice" mat-menu-item (click)="checkTimeStampBefore('rename', node)">
                {{'rename' | translation}}
              </button>
              <button *ngIf="!_firebase.user.assignedDevice" mat-menu-item (click)="checkTimeStampBefore('move', node.id)">
                {{'moveTo' | translation}}
              </button>
              <button *ngIf="!_firebase.user.assignedDevice" mat-menu-item (click)="checkTimeStampBefore('delete', node.id)">
                {{'delete' | translation}}
              </button>
            </mat-menu>
          </div>
        </mat-tree-node>
      </ng-container>
    </ng-container>
  </mat-tree>
</ng-container>
